module.exports = __webpack_public_path__ + "img/wf-finishing-position-13.a39ea7a8.svg";